export default "__VITE_ASSET__Bh$Bv1x0__"